import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Shield, Lock, Zap, Droplets } from 'lucide-react';
export function Pricing() {
  return <section id="checkout" className="py-20 px-4 bg-brand-surface border-t border-brand-border overflow-hidden" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <div className="text-center mb-10" data-id="element-109">
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-brand-text" data-id="element-110">
            ACCEDÉ AL MANUAL <span className="text-brand-green" data-id="element-111">COMPLETO</span>{' '}
            HOY
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="md:hidden mb-6 bg-gradient-to-br from-brand-green to-brand-greenHover text-white rounded-xl p-5 flex items-start gap-3 shadow-lg" data-id="element-112">
          <Droplets className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-113" />
          <div data-id="element-114">
            <p className="font-display text-xl leading-tight tracking-wide mb-1" data-id="element-115">
              QUE LOS PARTIDOS NO TE PESEN
            </p>
            <p className="text-sm leading-snug text-white/90" data-id="element-116">
              Calculadora de proteínas e hidratación incluida comprando hoy
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-brand-green rounded-2xl p-8 md:p-12 relative shadow-[0_20px_60px_rgba(22,163,74,0.15)]" data-id="element-117">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8,
          rotate: -8
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 6
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3,
          type: 'spring',
          stiffness: 120
        }} className="hidden md:flex absolute -right-10 lg:-right-24 top-1/2 -translate-y-1/2 w-56 lg:w-64 bg-gradient-to-br from-brand-green to-brand-greenHover text-white rounded-2xl p-5 flex-col gap-2 shadow-2xl shadow-brand-green/40 border-4 border-white z-10" data-id="element-118">
            <div className="absolute -top-3 -left-3 bg-yellow-400 text-brand-text font-bold text-[10px] uppercase px-2 py-1 rounded-full shadow-md tracking-wider" data-id="element-119">
              BONUS EXTRA
            </div>
            <Droplets className="w-10 h-10" data-id="element-120" />
            <p className="font-display text-2xl leading-[0.95] tracking-wide" data-id="element-121">
              QUE LOS PARTIDOS NO TE PESEN
            </p>
            <p className="text-sm leading-snug text-white/95" data-id="element-122">
              Calculadora de <strong data-id="element-123">proteínas e hidratación</strong> incluida
              comprando hoy
            </p>
          </motion.div>

          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-green text-white font-bold px-6 py-2 rounded-full text-sm md:text-base uppercase tracking-wider whitespace-nowrap shadow-md" data-id="element-124">
            Ahorrás más del 60%
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-125">
            <div data-id="element-126">
              <h3 className="text-2xl font-bold mb-6 text-brand-text" data-id="element-127">
                ¿Qué incluye tu acceso?
              </h3>
              <ul className="space-y-4" data-id="element-128">
                <li className="flex items-start gap-3" data-id="element-129">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-130" />
                  <span className="text-brand-text" data-id="element-131">
                    <strong data-id="element-132">El Manual del 5 Moderno</strong> (5 Capítulos
                    Completos)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-133">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-134" />
                  <span className="text-brand-text" data-id="element-135">
                    Bono 1: Atlas visual del 5 moderno
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-136">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-137" />
                  <span className="text-brand-text" data-id="element-138">
                    Bono 2: 30 ejercicios específicos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-139">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-140" />
                  <span className="text-brand-text" data-id="element-141">
                    Bono 3: Plan físico de 8 semanas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-142">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-143" />
                  <span className="text-brand-text" data-id="element-144">
                    Bono 4: Planilla de análisis
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-145">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-146" />
                  <span className="text-brand-text" data-id="element-147">
                    Bono 5: Guía de estudio profesional
                  </span>
                </li>
              </ul>
            </div>

            <div className="text-center bg-brand-surface p-8 rounded-xl border border-brand-border" data-id="element-148">
              <div className="text-brand-muted text-xl line-through mb-2 font-medium" data-id="element-149">
                $52.690
              </div>
              <div className="text-6xl font-display text-brand-green mb-6 tracking-wider" data-id="element-150">
                $19.990
              </div>

              <a href="https://checkout.ebookpoint.shop/cart/59546532511825" className="block w-full bg-brand-green hover:bg-brand-greenHover text-white font-display text-3xl py-5 px-6 rounded-lg uppercase tracking-wider transform transition-all hover:scale-105 active:scale-95 mb-6 shadow-lg shadow-brand-green/30" data-id="element-151">
                QUIERO MI MANUAL AHORA
              </a>

              <div className="flex flex-wrap justify-center gap-4 text-sm text-brand-muted" data-id="element-152">
                <div className="flex items-center gap-1" data-id="element-153">
                  <Lock className="w-4 h-4" data-id="element-154" /> Pago seguro
                </div>
                <div className="flex items-center gap-1" data-id="element-155">
                  <Zap className="w-4 h-4" data-id="element-156" /> Acceso inmediato
                </div>
                <div className="flex items-center gap-1" data-id="element-157">
                  <Shield className="w-4 h-4" data-id="element-158" /> Garantía 7 días
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}